var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlankProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "260.000000pt",
    height: "260.000000pt",
    viewBox: "0 0 260.000000 260.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,260.000000) scale(0.100000,-0.100000)",
    fill: "#D3D3D3",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1245 2399 c-146 -14 -280 -91 -371 -213 -95 -126 -133 -231 -141 -392 -7 -138 12 -233 69 -354 33 -68 57 -101 122 -166 119 -119 222 -164 376 -164 154 0 257 45 376 164 141 141 202 307 191 520 -8 161 -46 266 -140 391 -116 154 -293 233 -482 214z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623 881 c-188 -102 -352 -195 -364 -206 -49 -46 -59 -84 -59 -237 0 -124 3 -147 20 -175 40 -67 -25 -63 1082 -63 977 0 1004 1 1035 20 55 33 63 62 63 220 0 155 -11 194 -67 241 -16 13 -179 105 -362 203 -325 175 -334 179 -365 167 -144 -60 -161 -64 -276 -69 -126 -5 -220 13 -318 61 l-47 23 -342 -185z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankProfile);
export default __webpack_public_path__ + "static/media/blankProfile.b24fbfa33be8c792d9ff0a0af31cf5c8.svg";
export { ForwardRef as ReactComponent };